import {
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
  MDBSpinner
} from 'mdb-react-ui-kit';
import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router';
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import { Tooltip } from 'react-tooltip';
import { getFreshDeskAPIProfiles } from '../../apiclients/streamsapi_bridge';
import DeleteProfile from "../popups/freshdesk/DeleteFreshdeskProfile";
import PopupLoader from '../popups/PopupLoader';
import PopupLoaderNew from '../popups/PopupLoaderNew';
import { AddProfile } from '../popups/freshdesk/AddFreshdeskProfile';
import APITicketLogsPage from './APITicketLogsPage';
import StreamsAPIApps from './StreamsAPIApps';



function APILandingPage(props) {
  const { t, i18n } = useTranslation();
  const previewRef = useRef(null);
  const [isloading, setIsloading] = useState(false);
  const [internalError, setInternalError] = useState(false);
  const [apiProfiles, setApiProfiles] = useState([]);
  const [deleteProfile, setDeleteProfile] = useState(false);
  const [selectedProfileId, setSelectedProfileId] = useState();
  const [addProfile, setAddProfile] = useState(false);






  const togglePopup = () => setAddProfile(!addProfile);
  const dtogglePopup = () => setDeleteProfile(!deleteProfile);
  const addFreshDesklRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [basicActive, setBasicActive] = useState(location.state?.defaultTab || "tab3");

  useEffect(() => {
    console.log("isloading state changed:", isloading);
}, [isloading]);

  async function fetchFreshDeskAPIData() {
    try {
      setIsloading(true);
      setInternalError(false);
      const response = await getFreshDeskAPIProfiles(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      const rawData = await response.json();

      if (response.status === 200) {
        console.log(`rawData?.all_profiles is :::: ${rawData}`)
        setApiProfiles(rawData?.all_profiles ?? []);
      } else if (response.status === 500) {
        setInternalError(true);
      } else {
        navigate("/");
      }
    } catch (e) {
      console.log(`Unable to process the request:${e}`);
      setInternalError(true);
    } finally {
      setIsloading(false);
    }

  }

  let proccessdRows = [];
  apiProfiles.map((profile) => {
    console.log(`all_profiles are  :::: ${JSON.stringify(profile)}`)
    proccessdRows.push({
      profileInfo: profile,
      profileName: profile.profile_name,
      profileType: profile.profile_type,
      delete: (
        <>
          <div className="d-flex align-items-center justify-content-center">
            <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => deletethisProfile(e, profile.profileid)}>
              <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
            </div>
          </div>
        </>
      )
    });
  });

  function deletethisProfile(evntData, profileId) {
    evntData.preventDefault();
    evntData.stopPropagation();
    setSelectedProfileId(profileId)
    setDeleteProfile(true)
  }


  useEffect(() => {
    fetchFreshDeskAPIData();
  }, []);



  function showThisInfo(tdata) {
    navigate("/apidetails", {
      state: tdata.profileInfo,
    });
  }

  const basicData2 = {
    columns: [
      { label: 'API Profile Name', field: 'profileName', sort: true },
      { label: 'Type', field: 'profileType' },
      { label: 'Remove', field: 'delete', sort: false },
    ],
    rows: proccessdRows
  };

  
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };


  function handleClick() {
    addFreshDesklRef.current.click();
  }


  return (
    <React.Fragment>
      <>
        <MainLinks active={6} />
        <Body
          tablinks={6}
          sublink={4}
          content={
            <>

              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    {/* <h5 className="mb-0 ">{t("freshdeskapi")}</h5> */}
                  </div>
                  <div>

                    <MDBTabs className='mb-3'>
                      {/* <MDBTabsItem>
                        <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                          {t("api")}
                        </MDBTabsLink>
                    </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                          {t("APITicketLogs")}
                        </MDBTabsLink>
                      </MDBTabsItem> */}
                      <MDBTabsItem>
                        <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
                          {t("Streams API Apps")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBTabsContent>
                      {/* <MDBTabsPane open={basicActive === 'tab1'}>

                        <div className="d-flex align-items-center justify-content-between actionbar">
                          <div className='me-2'>
                            <MDBBtn
                              className="green-button d-inline-block float-end"
                              data-mdb-toggle="modal"
                              data-mdb-target="#exampleModal"
                              onClick={togglePopup}
                            >
                              <MDBIcon fas icon="add" size="sm" className='me-2' />Add API Profile
                            </MDBBtn>
                          </div>
                        </div>

                        <div className="apiDataTable">
                          <MDBDatatable search sortField="API Profile Name" data={basicData2} onRowClick={(event, rowData) => {
                            showThisInfo(event);
                          }} className='actioncolumnbig' />
                        </div>

                      </MDBTabsPane>
                      <MDBTabsPane open={basicActive === 'tab2'}>
                        <APITicketLogsPage
                          setIsloading={setIsloading}
                          setInternalError={setInternalError}
                        /> */}

                      {/* </MDBTabsPane> */}
                      <MDBTabsPane open={basicActive === 'tab3'}>
                        <StreamsAPIApps active={basicActive === 'tab3'} />
                      </MDBTabsPane>
                    </MDBTabsContent>

                  </div>
                </div>
              </section>
              <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Remove
              </Tooltip>
              {/* {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )} */}

              {addProfile && (
                <PopupLoaderNew
                  title={"Add API Profile"}
                  content={<AddProfile onClose={togglePopup}
                    ref={addFreshDesklRef}
                    setIsloading={setIsloading}
                  />}
                  onShow={setAddProfile}
                  onClose={togglePopup}
                  onSave={handleClick}
                  isloading={isloading}
                  flag={1}
                />
              )}
            </>
          }
        />

        {deleteProfile && (
          <PopupLoader
            title={"Remove Freshdesk Profile"}
            content={<DeleteProfile profileId={selectedProfileId} onClose={dtogglePopup} />}
            onShow={setDeleteProfile}
            onClose={dtogglePopup}
          />
        )}
      </>
    </React.Fragment>
  );
}

export default APILandingPage;
